import React, { useEffect, useState } from "react";
import SoundMap from "../components/SoundMap";
import SoundStations from "../components/SoundStations";
import { useDispatch } from "react-redux";
import { fetchSound } from "../store/sound";
import { fetchInfo } from "../store/information";
import {
  fetchLeqHourly,
  fetchLeqNighttime,
  fetchLeqDaily,
  fetchLeqDaytime,
} from "../store/leq";

const SoundPayesh = () => {
  const dispatch = useDispatch();
  const [dataType, setDataType] = useState("spl");

  useEffect(() => {
    const fetchData = () => {
      switch (dataType) {
        case "spl":
          dispatch(fetchSound());
          break;
        case "hourly":
          dispatch(fetchLeqHourly());
          break;
        case "nighttime":
          dispatch(fetchLeqNighttime());
          break;
        case "daytime":
          dispatch(fetchLeqDaytime());
          break;
        case "daily":
          dispatch(fetchLeqDaily());
          break;
        default:
          break;
      }
      dispatch(fetchInfo());
    };
    fetchData();
    const intervalId = setInterval(fetchData, 1500000); // 1500000 ms = 25 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [dispatch, dataType]);

  return (
    <div>
      <SoundMap dataType={dataType} setDataType={setDataType}></SoundMap>
      <SoundStations dataType={dataType} />
    </div>
  );
};

export default SoundPayesh;
